/* FG product card — shared behavior, extracted from snippets/product-card.liquid
   so it is parsed once per page instead of once per card.
   Global delegate (idempotent across cart-drawer re-renders). */
if (!window.__fgCardSwatchInit) {
  window.__fgCardSwatchInit = true;

  function applySoldOutState(form, soldOut) {
    if (!form) return;
    form.classList.toggle('is-sold-out', !!soldOut);
    form.querySelectorAll('button[type="submit"]').forEach(function(btn) {
      if (soldOut) {
        btn.disabled = true;
        btn.setAttribute('aria-label', 'Sold out');
      } else {
        btn.disabled = false;
        btn.removeAttribute('aria-label');
      }
    });
  }

  document.addEventListener('click', function(e) {
    var sw = e.target.closest('.fg-color-swatch');
    if (!sw) return;
    var card = sw.closest('product-card');
    if (!card) return;
    e.preventDefault();
    e.stopPropagation();

    // 1. swap main image
    var imgUrl = sw.getAttribute('data-variant-img');
    var primary = card.querySelector('.product-card__image--primary');
    if (imgUrl && primary) {
      primary.removeAttribute('srcset');
      primary.removeAttribute('data-srcset');
      primary.src = imgUrl;
    }

    // 2. active state
    card.querySelectorAll('.fg-color-swatch').forEach(function(el) { el.classList.remove('is-active'); });
    sw.classList.add('is-active');

    // 3. sync hidden variant id
    var variantId = sw.getAttribute('data-variant-id');
    var input = card.querySelector('[data-fg-variant-input]');
    if (input && variantId) input.value = variantId;

    // 4. sold-out state
    var soldOut = sw.getAttribute('data-variant-available') === 'false';
    applySoldOutState(card.querySelector('.fg-quickbuy-form'), soldOut);
  }, true /* capture, runs before product-card's own handlers */);

  /* Initialize sold-out state for all cards on page load (in case the default selected variant is sold out) */
  function syncAllCards() {
    document.querySelectorAll('product-card').forEach(function(card) {
      var active = card.querySelector('.fg-color-swatch.is-active') || card.querySelector('.fg-color-swatch');
      if (!active) return;
      applySoldOutState(card.querySelector('.fg-quickbuy-form'), active.getAttribute('data-variant-available') === 'false');
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAllCards);
  } else {
    syncAllCards();
  }

  /* Toast feedback when an item is successfully added to cart */
  function showToast(msg) {
    var t = document.getElementById('fg-cart-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'fg-cart-toast';
      t.style.cssText = 'position:fixed;left:50%;bottom:32px;transform:translateX(-50%);background:#1a2e14;color:#fff;padding:12px 22px;border-radius:6px;font-size:14px;font-weight:600;z-index:99999;box-shadow:0 6px 20px rgba(0,0,0,.25);opacity:0;pointer-events:none;transition:opacity .25s,transform .25s;';
      document.body.appendChild(t);
    }
    t.textContent = msg;
    requestAnimationFrame(function() {
      t.style.opacity = '1';
      t.style.transform = 'translateX(-50%) translateY(0)';
    });
    clearTimeout(t._fgTimer);
    t._fgTimer = setTimeout(function() { t.style.opacity = '0'; }, 2200);
  }

  /* Listen for theme's `variant:add` event — fired after successful AJAX add to cart */
  document.addEventListener('variant:add', function(e) {
    var items = e.detail && e.detail.items;
    var firstTitle = items && items[0] && (items[0].product_title || items[0].title);
    showToast(firstTitle ? '✓ Added: ' + firstTitle : '✓ Added to cart');

    /* Reset every quick-buy button so users can keep adding more. */
    document.querySelectorAll('.fg-quickbuy-form').forEach(function(form) {
      var card = form.closest('product-card');
      var active = card && (card.querySelector('.fg-color-swatch.is-active') || card.querySelector('.fg-color-swatch'));
      var soldOut = active ? active.getAttribute('data-variant-available') === 'false' : false;
      applySoldOutState(form, soldOut);
      form.querySelectorAll('button[type="submit"]').forEach(function(btn) {
        btn.removeAttribute('aria-busy');
        btn.classList.remove('is-loading', 'loading');
      });
    });
  });

  /* Same reset on cart:change as a safety net */
  document.addEventListener('cart:change', function() {
    document.querySelectorAll('.fg-quickbuy-form').forEach(function(form) {
      var card = form.closest('product-card');
      var active = card && (card.querySelector('.fg-color-swatch.is-active') || card.querySelector('.fg-color-swatch'));
      var soldOut = active ? active.getAttribute('data-variant-available') === 'false' : false;
      applySoldOutState(form, soldOut);
      form.querySelectorAll('button[type="submit"]').forEach(function(btn) {
        btn.removeAttribute('aria-busy');
        btn.classList.remove('is-loading', 'loading');
      });
    });
  });
}
